"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMRLocations = exports.defaultMRLocationData = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultMRLocationData = exports.defaultMRLocationData = {
  id: null,
  name: ''
};
const getMRLocations = params => (0, _request.default)({
  url: '/mr-locations',
  method: 'get',
  params
});
exports.getMRLocations = getMRLocations;